import Axios from "axios";
import {
  SET_LC_EXPORT_PI_LIST,
  UNSET_LC_EXPORT_PI_LIST,
  SET_EDITING_LC_EXPORT_PI,
  UNSET_EDITING_LC_EXPORT_PI,
} from "@/store/mutation-types";
import {
  saveUpdateLcExportPi,
  getLcExportPiList,
  getLcExportPiById as getLcExportPiByIdApi,
} from "@/store/api";

// initial state
const state = {
  lcExportPiList: [],
  editingLcExportPi: null,
};

const getters = {
  getLcExportPiList(state) {
    return state.lcExportPiList;
  },
  getEditingLcExportPi(state) {
    return state.editingLcExportPi;
  },
};

const mutations = {
  [SET_LC_EXPORT_PI_LIST](state, data) {
    state.lcExportPiList = data;
  },
  [UNSET_LC_EXPORT_PI_LIST](state) {
    state.lcExportPiList = [];
  },
  [SET_EDITING_LC_EXPORT_PI](state, data) {
    state.editingLcExportPi = data;
  },
  [UNSET_EDITING_LC_EXPORT_PI](state) {
    state.editingLcExportPi = null;
  },
};

const actions = {
  saveUpdateLcExportPi({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcExportPi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcExportPiList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcExportPiList)
        .then(function (response) {
          commit(SET_LC_EXPORT_PI_LIST, response.data.data || []);
          resolve(response);
        })
        .catch(function (error) {
          commit(UNSET_LC_EXPORT_PI_LIST);
          reject(error);
        });
    });
  },

  getLcExportPiById({ commit }, id) {
    const url = `${getLcExportPiByIdApi}${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          commit(SET_EDITING_LC_EXPORT_PI, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

